import { isHPItgLive } from '@storefront/utils/utils';
import {
  signIn,
  SignInAuthorizationParams,
  SignInOptions,
  signOut,
} from 'next-auth/react';
import { env } from 'next-runtime-env';

interface SignOutHandlerOptions {
  path?: string;
  redirect: boolean;
}

interface SignInHandlerOptions {
  options?: SignInOptions;
  authorizationParams?: SignInAuthorizationParams;
  path?: string;
}
export const signOutHandler = ({
  path = '',
  redirect,
}: SignOutHandlerOptions) => {
  if (!redirect) {
    return signOut({ redirect });
  }
  const isITG = isHPItgLive();
  const callbackUrl = `${
    isITG ? env('NEXT_PUBLIC_ITG_DOMAIN') : env('NEXT_PUBLIC_APP_DOMAIN')
  }${path}`;

  return signOut({ callbackUrl });
};

export const signInHandler = ({
  path = '',
  options,
  authorizationParams,
}: SignInHandlerOptions) => {
  const isITG = isHPItgLive();
  const callbackUrl = `${
    isITG ? env('NEXT_PUBLIC_ITG_DOMAIN') : env('NEXT_PUBLIC_APP_DOMAIN')
  }${path}`;
  return signIn(
    'authz',
    {
      ...options,
      callbackUrl,
    },
    authorizationParams
  );
};
